import styled from '@emotion/styled';
import InputWithEscListener from '@/components/InputWithEscListener';
import addBorderInHighContrastMode from '@/lib/styling/addBorderInHighContrastMode';

const GroupNameInput = styled(InputWithEscListener)(
  ({ theme }) => ({
    marginRight: 6,
    padding: '6px 8px',
    flex: 1,
    backgroundColor: theme.palette.background.shaded,
    fontFamily: 'CircularStd',
    borderRadius: 4,
  }),
  addBorderInHighContrastMode,
) as typeof InputWithEscListener;

export default GroupNameInput;
